import React from 'react'
import Navber from "./Navber.jsx"
import HeroSection from './HeroSection.jsx'
import { motion } from "framer-motion";
import GalleryPreview from './GalleryPreview.jsx';
import WeddingIntroSection from './WeddingIntroSection.jsx';
import OurStory from './OurStory.jsx';
import ServicesSlider from './ServicesSlider.jsx';
import BookEvent from './BookEvent.jsx';
import Packages from './Packages.jsx';
import ContactSection from './ContactSection.jsx';
import Footer from './Footer.jsx';

import Testimonial from './Testimonial.jsx';

import "./Home.css";
import Misscelinous from './Misscelinous.jsx';
function Home() {
  return (
    <div>
<Navber/>
<section id='hero'>
<HeroSection/>
</section>
<section id='about'>
<OurStory/>
</section>
<section id='events'>
<ServicesSlider/>
</section>
<section id='contact'>
  <BookEvent/>

</section>
<section id='packages'>
<Packages/>
</section>
<section id='gallery'>
    <GalleryPreview/>
    </section>
  <Misscelinous/>
<Testimonial/>
<ContactSection/>
<Footer/>
    {/* <motion.div
      className="venue-container"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <h3 className="venue-title">Venue Highlights</h3>
      <hr className="venue-line" />

      <div className="venue-grid">
        <div className="venue-col">
          <h4 className="venue-label">Capacity</h4>
          <p className="venue-value">Upto 1000 guests</p>
        </div>

        <div className="venue-col">
          <h4 className="venue-label">Location</h4>
          <p className="venue-value">Near Ganges</p>
        </div>

        <div className="venue-col">
          <h4 className="venue-label">Amenities</h4>
          <p className="venue-value">Catering, decor, music</p>
        </div>
      </div>

      <hr className="venue-line" />
    </motion.div> */}

    {/* <WeddingIntroSection/> */}
    </div>
  )
}

export default Home